<template>
  <div class="collapsible" :class="{ active: isExpand }">
    <div class="header">
      <span class="header-text">
        <span class="title">
          {{ title }}
        </span>
        <span v-if="subTitle" class="subtitle"> ({{ subTitle }}) </span>
      </span>
      <span class="header-toggle" @click="emitToggle">
        <FeatherIcon v-if="isExpand" type="chevron-up" />
        <FeatherIcon v-else type="chevron-down" />
      </span>
    </div>
    <div v-show="isExpand" class="content-expand">
      <slot name="expand"></slot>
    </div>
    <div v-show="!isExpand" class="content-collapse">
      <slot name="collapse">
        <a-tag v-for="c in tags" :key="c.name" class="s-tag">
          {{ c.text }}
        </a-tag>
      </slot>
    </div>
  </div>
</template>

<script>
import { toRef } from 'vue';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: [String, Number],
      default: '',
    },
    isExpand: Boolean,
    isTransform: Boolean,
    tags: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['toggle'],
  setup(props, { emit }) {
    const title = toRef(props, 'title');
    const isExpand = toRef(props, 'isExpand');
    const emitToggle = () => {
      emit('toggle', { title: title.value, value: !isExpand.value });
    };
    return {
      emitToggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.collapsible {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f2f6;
  &.active {
    background-color: #fbfbfc;
  }
  .header {
    display: flex;
    justify-content: space-between;
    .header-text {
      line-height: 26px;
      user-select: none;
      .title {
        font-size: 16px;
        color: #272b41;
        font-weight: 500;
      }
      .subtitle {
        font-size: 12px;
        color: #9299b8;
      }
    }
    .header-toggle {
      cursor: pointer;
      color: #272b41;
      &:hover {
        color: #40a9ff;
      }
    }
  }
  .content-collapse {
    .s-tag {
      user-select: none;
    }
  }
}
</style>
